import { createFileRoute } from '@tanstack/react-router';
import { ConvertedListPage } from '../../../features/crm';
import { usePageTitle } from '../../../lib/hooks';

export const Route = createFileRoute('/_auth/crm/converted')({
  component: ConvertedRoute,
});

function ConvertedRoute() {
  usePageTitle('Converted');
  return <ConvertedListPage />;
}
